<h1 mat-dialog-title>Annuller serviceordre {{ data.serviceordreNo }}</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <form [formGroup]="form">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Angiv årsag til anullering</mat-label>
        <input formControlName="note" matInput />
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button mat-dialog-close>Fortryd</button>
  <button
    mat-raised-button
    color="primary"
    (click)="annuller()"
    [disabled]="!canConfirm"
  >
    Annuller ordre
  </button>
</div>
